import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToElement } from '../../../../utils/scrollToElement';

const useHashScroll = (shouldAddTabsOffset: boolean, isPageLoadingCompleted: boolean = true) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!isPageLoadingCompleted) {
      return;
    }

    if (hash) {
      const element = document.querySelector<HTMLElement>(hash);
      const siteHeader = document.getElementById('site-header');

      if (element) {
        element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: true });

        setTimeout(() => {
          if (shouldAddTabsOffset) {
            const tabs = window.innerWidth > 768 ? document.getElementById('routed-tabs') : null;
            const tabsHeight = tabs?.offsetHeight || 0;
            const headerHeight = siteHeader?.offsetHeight || 0;
            scrollToElement(
              element,
              element.getBoundingClientRect().top > 160 ? tabsHeight - headerHeight : tabsHeight,
            );
          } else {
            scrollToElement(element);
          }
        }, 500);
      }
    }
  }, [hash, isPageLoadingCompleted, shouldAddTabsOffset]);
};

export default useHashScroll;
